<template>
  <div class="company-core-add">
    <div class="company-core-add-head">
      <bcc-breadcrumb>
        <bcc-breadcrumb-item>管理中心</bcc-breadcrumb-item>
        <bcc-breadcrumb-item
          :to="{ name: 'companyCore' }"
          @click.native="
            $LogReport.sendCustomEvent('openplat_newapp_backto_appmanage')
          "
          >应用管理
        </bcc-breadcrumb-item>
        <bcc-breadcrumb-item>创建应用</bcc-breadcrumb-item>
      </bcc-breadcrumb>
    </div>
    <div class="company-core-add-body">
      <div class="company-core-add-body-h">我的应用</div>
      <div class="company-core-add-form">

        <div class="line"></div>
        <div class="h2">
          应用信息
          <span class="tips" style="color: red; font-size: 12px"
            >&nbsp; * 应用过审后,
            当"应用名称"、"应用网址"、"应用简介"、"应用图标"发生更改时,
            会对应用进行审核, 审核时, 本次修改的内容都暂时不会生效,
            审核通过后统一生效。</span
          >
        </div>

        <validator
          :value="companyCoreName"
          name="应用名称"
          :validator="validator.companyCoreName"
        >
          <div class="form-item">
            <span class="label"> <i class="required">*</i>应用名称 </span>
            <bcc-input
              :disabled="isEditWebhooks"
              maxlength="20"
              style="flex: 1"
              placeholder="请正确填写应用名称，在授权等操作中展示给用户"
              v-model="companyCoreName"
              @blur="verrifyAppName"
              @input="appNameExist = false"
              showWordLimit
              :isError="validator.companyCoreName.showError"
            ></bcc-input>
          </div>
          <p class="exit-name" v-if="appNameExist">该名称已被占用</p>
        </validator>
        <validator
          :value="companyCoreHomeAddr"
          name="应用网址"
          :validator="validator.companyCoreHomeAddr"
        >
          <div class="form-item">
            <span class="label"> <i class="required">*</i>应用网址 </span>
            <bcc-input
              :disabled="isEditWebhooks"
              v-model="companyCoreHomeAddr"
              style="flex: 1"
              :isError="validator.companyCoreHomeAddr.showError"
              placeholder="请填写官网信息，官网地址需能够正常打开，例如：https://bilibili.com"
            ></bcc-input>
          </div>
        </validator>
        <validator
          :value="companyCoreDescription"
          name="应用简介"
          :validator="validator.companyCoreDescription"
        >
          <div class="form-item" style="align-items: flex-start">
            <span class="label" style="margin-top: 8px">
              <i class="required">*</i>应用简介
            </span>
            <bcc-input
              :disabled="isEditWebhooks"
              minlength="5"
              maxlength="80"
              type="textarea"
              style="flex: 1"
              placeholder="请描述应用预计接入的目标、核心功能、实际使用场景等"
              v-model="companyCoreDescription"
              :isError="validator.companyCoreDescription.showError"
              showWordLimit
            ></bcc-input>
          </div>
        </validator>
        <div class="form-item" style="align-items: flex-start">
          <span class="label"> <i class="required">*</i>应用图标 </span>
          <ac-file-upload
            type="image"
            accept=".png"
            :uploader="iconUploader"
            :source="iconUrl"
            style="width: 108px; height: 108px"
            ref="icon"
          ></ac-file-upload>
          <div class="tip">
            应用图标将在哔哩哔哩授权登陆等操作时被用户看到，请规范上传
            <div class="highlight">
              1.仅支持PNG格式；<br />
              2.尺寸为150*150像素，大小不超过400K；
            </div>
          </div>
        </div>
        <!-- <validator 
        v-if='companyCoreAddType.includes(1)' :value="companyCoreCallbackURL" name='授权回调域' :validator='validator.companyCoreCallbackURL'>
        <div class="form-item" style="align-items: baseline">
          <span class="label">
            <i class="required">*</i>授权回调域
          </span>
          <div style="flex: 1">
            <div class="tip" style="margin-left: 8px">需按规范正确输入授权回调域</div>
            <bcc-input
              :disabled='isEditWebhooks'
              v-model="companyCoreCallbackURL"
              placeholder="最多可填写三域名，需要用英文分号隔开。例：https://open.bilibili.com;https://mcn.bilibili.com"
              style="width: 100%; margin-top: 17px"
              :isError='validator.companyCoreCallbackURL.showError'
            ></bcc-input>
          </div>
        </div>
        </validator> -->
        <div>
          <div class="line"></div>
          <div class="h2">
            平台信息
            <span
              class="tip"
              :class="become ? 'tip-red' : ''"
              style="font-weight: 400"
              >请至少选择一个平台</span
            >
          </div>

          <div>
            <div class="form-item">
              <bcc-checkbox :disabled="isEditWebhooks" v-model="iOS"
                >iOS应用</bcc-checkbox
              >
            </div>
            <div v-show="iOS">
              <div class="form-item">
                <span class="label"> <i class="required">*</i>应用已上架 </span>
                <div style="flex: 1; margin-left: 18px">
                  <bcc-radio-group
                    :disabled="isEditWebhooks"
                    v-model="iOSPublished"
                  >
                    <bcc-radio :label="2">是</bcc-radio>
                    <bcc-radio :label="1" style="margin-left: 32px"
                      >否</bcc-radio
                    >
                  </bcc-radio-group>
                </div>
              </div>
              <div class="form-item">
                <span class="app-label"> AppStore下载地址 </span>
                <bcc-input
                  :disabled="isEditWebhooks"
                  style="flex: 1"
                  placeholder="AppStore中下载地址，若未上线，可后续上线后进行填写"
                  v-model="appStoreURL"
                ></bcc-input>
              </div>
              <validator
                :value="bundleId"
                name="Bundle ID"
                :validator="validator.bundleId"
              >
                <div class="form-item">
                  <span class="app-label">
                    <i class="required">*</i>Bundle ID
                  </span>
                  <bcc-input
                    :disabled="isEditWebhooks"
                    style="flex: 1"
                    placeholder="iOS应用唯一标识"
                    v-model="bundleId"
                    :isError="validator.bundleId.showError"
                  ></bcc-input>
                </div>
              </validator>
            </div>
          </div>
          <div>
            <div class="form-item" style="margin-top: 65px">
              <bcc-checkbox :disabled="isEditWebhooks" v-model="android"
                >Android应用</bcc-checkbox
              >
            </div>
            <div v-show="android">
              <div class="form-item">
                <span class="label"> <i class="required">*</i>应用已上架 </span>
                <div style="flex: 1; margin-left: 18px">
                  <bcc-radio-group
                    :disabled="isEditWebhooks"
                    v-model="androidPublished"
                  >
                    <bcc-radio :label="2">是</bcc-radio>
                    <bcc-radio :label="1" style="margin-left: 32px"
                      >否</bcc-radio
                    >
                  </bcc-radio-group>
                </div>
              </div>
              <div class="form-item">
                <span class="app-label"> Android下载地址 </span>
                <bcc-input
                  :disabled="isEditWebhooks"
                  style="flex: 1"
                  placeholder="Android应用商店中的下载地址，不可以直接使用apk包名的下载地址，若未上线，可后续待应用上线后再进行修改"
                  v-model="androidStoreURL"
                ></bcc-input>
              </div>
              <validator
                :value="packageName"
                name="应用包名"
                :validator="validator.packageName"
              >
                <div class="form-item">
                  <span class="app-label">
                    <i class="required">*</i>应用包名
                  </span>
                  <bcc-input
                    :disabled="isEditWebhooks"
                    style="flex: 1"
                    placeholder="应用在一台设备上的唯一标识，在manifest文件里声明，该包名和正式发布应用的包名一致。例如com.bilibili.mm"
                    v-model="packageName"
                    :isError="validator.packageName.showError"
                  ></bcc-input>
                </div>
              </validator>
              <validator
                :value="signatureName"
                name="应用签名"
                :validator="validator.signatureName"
              >
                <div class="form-item">
                  <span class="app-label">
                    <i class="required">*</i>应用签名
                  </span>
                  <bcc-input
                    :disabled="isEditWebhooks"
                    type="textarea"
                    rows="2"
                    style="flex: 1"
                    :isError="validator.signatureName.showError"
                    placeholder="用于对当前应用进行二次身份校验，开发者可以使用签名生成工具直接从安装当前应用的手机中获取。应用签名由开发者签名该应用的keystore文件决定"
                    v-model="signatureName"
                  ></bcc-input>
                </div>
              </validator>
            </div>
          </div>
          <div>
            <div class="form-item" style="margin-top: 65px">
              <bcc-checkbox :disabled="isEditWebhooks" v-model="PC"
                >网页应用</bcc-checkbox
              >
            </div>
            <div v-show="PC">
              <validator
                v-if="PC"
                :value="companyCoreCallbackURL"
                name="应用回调域"
                :validator="validator.companyCoreCallbackURL"
              >
                <div class="form-item">
                  <span class="app-label">
                    <i class="required">*</i>
                    应用回调域
                  </span>
                  <bcc-input
                    :disabled="isEditWebhooks"
                    style="flex: 1"
                    placeholder="最多可填写三域名，需要用英文分号隔开。例：https://open.bilibili.com;https://mcn.bilibili.com"
                    v-model="companyCoreCallbackURL"
                    :isError="validator.companyCoreCallbackURL.showError"
                  ></bcc-input>
                </div>
              </validator>
            </div>
          </div>
        </div>
        <div>
          <div class="line"></div>
          <div class="h2">
            应用安全测试
            <bcc-popover placement="right" trigger="hover" :zIndex="10">
              <v-icon slot="reference" class="help-img" name="help" />
              <slot name="content">
                <div class="des-txt">
                  <p>
                    <span>注:</span>
                    1.勾选“通过测试”则表示您已对应用进行相应测试，并保证测试结果的真实性；
                  </p>
                  <p class="text-indent">
                    2.如有测试项尚未满足控制条件，您可暂时勾选“未通过测试”，但需在应用申请提交后14日内完成整改，并在【应用管理】-【查看应用详情】中，点击“编辑”，更新应用测试结果；否则，开放平台将对应用进行驳回处理；
                  </p>
                  <p class="text-indent">
                    3.具体安全测试方法，详见
                    <a
                      target="_blank"
                      :href="app_safety_test"
                      download="哔哩哔哩开放平台安全测试方法.pdf"
                      >《安全测试方法》</a
                    >
                  </p>
                </div>
              </slot>
            </bcc-popover>
          </div>
          <div
            v-for="(item, idx) in safetyList"
            :key="idx"
            class="form-item app-test"
          >
            <div class="container">
              <span class="label">
                <i class="required">*</i>{{ item.title.split("（")[0] }}
              </span>
              <bcc-radio-group
                v-model="safety_test_report[item.code]"
                @on-change="handleTestChange"
              >
                <bcc-radio
                  v-for="(itm, idx) in resultList"
                  :key="idx"
                  :label="itm.code"
                  >{{ itm.title }}</bcc-radio
                >
              </bcc-radio-group>
            </div>
            <p class="app-test-txt">
              {{ item.title.split("（")[1].slice(0, -1) }}
            </p>
          </div>
        </div>
        <div class="line"></div>
        <div class="h2">管理者信息</div>
        <validator
          :value="adminName"
          name="联系人"
          :validator="validator.adminName"
        >
          <div class="form-item">
            <span class="label"> <i class="required">*</i>联系人 </span>
            <bcc-input
              :disabled="isEditWebhooks"
              maxlength="20"
              style="flex: 1"
              placeholder="请填写运营者身份证的名字，名字中如果包含分隔符“.”，请完整输入"
              :isError="validator.adminName.showError"
              v-model="adminName"
              showWordLimit
            ></bcc-input>
          </div>
        </validator>
        <validator
          :value="adminMail"
          name="联系邮箱"
          :validator="validator.adminMail"
        >
          <div class="form-item">
            <span class="label"> <i class="required">*</i>联系邮箱 </span>
            <bcc-input
              :disabled="isEditWebhooks"
              style="flex: 1"
              placeholder="请填写联系邮箱，如abc@bilibili.com"
              v-model="adminMail"
              :isError="validator.adminMail.showError"
            ></bcc-input>
          </div>
        </validator>
        <validator
          :value="adminPhone"
          name="联系手机"
          :validator="validator.adminPhone"
        >
          <div class="form-item">
            <span class="label"> <i class="required">*</i>联系手机 </span>
            <bcc-input
              style="flex: 1"
              placeholder="请填写正常的手机号，以便及时接收短信"
              v-model="adminPhone"
              :isError="validator.adminPhone.showError"
              :disabled="!canInputPhone || isEditWebhooks"
            ></bcc-input>
            <bcc-verification
              :is-async="true"
              ref="bcc-verification"
              @click="sendVerification"
              :disabled="!canSendCaptcha"
              style="margin-left: 15px"
            ></bcc-verification>
          </div>
        </validator>
        <validator
          :value="adminPhone"
          name="联系手机"
          :validator="validator.adminPhone"
        >
          <div class="form-item">
            <span class="label"> <i class="required">*</i>验证码 </span>
            <bcc-input
              style="flex: 1"
              v-model="verificationCode"
              :disabled="!canSendCaptcha"
            ></bcc-input>
          </div>
        </validator>
        <template v-if="isEditWebhooks">
          <div class="line"></div>
          <div class="h2">Webhooks用户事件推送</div>
          <validator
            ref="callback_url"
            :value="callback_url"
            name="webhooks回调地址"
            :validator="validator.callback_url"
          >
            <div class="form-item">
              <span class="webhooks-label"> 消息回调地址 </span>
              <bcc-input
                @blur="handleWebhooks"
                @change="changeStatus"
                style="flex: 1"
                placeholder="请填写Webhooks的消息回调地址"
                v-model="callback_url"
                :disabled="webhooksLoading"
                :isError="validator.callback_url.showError"
              ></bcc-input>
              <v-icon
                v-if="webhooksLoading"
                class="validate-icon rotate"
                :style="{
                  color: '#ddd',
                }"
                name="validate"
              />
            </div>
          </validator>
          <div class="webhooks-txt">
            此地址用于接收用户事件触发的反向通知，例：B站用户授权给应用
            <a
              href="http://openhome.bilibili.com/doc/4/b369a652-0e26-8ddb-74f0-20c74234fcd6"
              >详细说明</a
            >
          </div>
        </template>
      </div>
      <div class="line"></div>
      <div style="text-align: center">
        <bcc-button
          v-if="isEditWebhooks"
          :disabled="upsetDisabled || lock === 1"
          size="max-large"
          type="primary"
          style="margin: 31px 0 35px 0"
          @click="upsetWebhooks"
          >提交
        </bcc-button>
        <bcc-button
          v-else
          size="max-large"
          type="primary"
          style="margin: 31px 0 35px 0"
          @click="confirmAddCompanyCore"
          >提交
        </bcc-button>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from "./validateWrap";
import axios from "axios";
import { whether } from "../../apis/company-core";
export default {
  name: "companyCoreAdd",
  components: {
    Validator,
  },
  computed: {
    isEditWebhooks() {
      return Boolean(this.$route.query.webhooks);
    },
    canValidate() {
      return this.webhooksLoading || !this.callback_url;
    },
  },
  data() {
    return {
      become: false,
      safety_test_report: {},
      app_safety_test: `//${
        window.$bili_arcopen.isUAT ? "uat-" : ""
      }s1.hdslb.com/bfs/templar/york-static/oo1cx389KojPWVlZ.pdf`,
      safetyList: [],
      resultList: [],
      prev: "",
      upsetDisabled: false,
      callback_url: "",
      webhooksLoading: false,
      companyCoreName: "",
      companyCoreAddType: 1,
      companyCoreDescription: "",
      iconUrl: "",
      adminName: "",
      adminMail: "",
      adminPhone: "",
      iOSPublished: 1,
      androidPublished: 1,
      iOS: false,
      android: false,
      PC: false,
      appStoreURL: "",
      bundleId: "",
      universalLinks: "",
      androidStoreURL: "",
      packageName: "",
      // companyCoreCallbackURL: '',
      signatureName: "",
      verificationCode: "",
      companyCoreAddPlat: [],
      companyCoreHomeAddr: "",
      companyCoreCallbackURL: "",
      webAuthInfo: {},
      iOSAuthInfo: {},
      androidAuthInfo: {},
      oldAdminPhone: "",
      canSendCaptcha: false,
      canInputPhone: true,
      appNameExist: false,
      validator: {
        callback_url: {
          showError: false,
          // required: true,
          validatorList: [
            {
              func: () => {
                if (!this.callback_url) {
                  return true;
                } else {
                  return /^https?:\/\//.test(this.callback_url);
                }
              },
              error: "回调地址不正确，无法验证",
            },
          ],
          errorStyle: {
            "margin-left": "140px",
          },
        },
        companyCoreName: {
          showError: false,
          required: true,
          validatorList: [
            {
              func: () => {
                return this.companyCoreName.length > 1;
              },
              error: "最少输入两个字符",
            },
            {
              func: () => {
                return !/\s/.test(this.companyCoreName);
              },
              error: "不能包含空格",
            },
          ],
        },
        companyCoreHomeAddr: {
          showError: false,
          required: true,
          validatorList: [
            {
              func: () => {
                return /^https?:\/\//.test(this.companyCoreHomeAddr);
              },
              error: "应用网址不正确",
            },
            {
              func: () => {
                return !/\s/.test(this.companyCoreHomeAddr);
              },
              error: "不能包含空格",
            },
          ],
        },
        companyCoreDescription: {
          showError: false,
          required: true,
          validatorList: [
            {
              func: () => {
                return this.companyCoreDescription.length > 4;
              },
              error: "请最少输入5个字的应用简介",
            },
          ],
        },
        // companyCoreCallbackURL: {
        //   showError: false,
        //   required: true,
        //   validatorList: [{
        //     func: () => {
        //       return /^https?:\/\//.test(this.companyCoreCallbackURL)
        //     },
        //     error: '授权回调域内容地址不正确',
        //   }]
        // },
        bundleId: {
          showError: false,
          required: true,
          errorStyle: {
            "margin-left": "160px",
          },
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.bundleId);
              },
              error: "不能包含空格",
            },
          ],
        },
        packageName: {
          showError: false,
          required: true,
          errorStyle: {
            "margin-left": "160px",
          },
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.packageName);
              },
              error: "不能包含空格",
            },
          ],
        },
        companyCoreCallbackURL: {
          showError: false,
          required: true,
          errorStyle: {
            "margin-left": "160px",
          },
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.companyCoreCallbackURL);
              },
              error: "不能包含空格",
            },
            {
              func: () => {
                const urlArr = this.companyCoreCallbackURL.split(";");
                const flag = urlArr.every((item) => {
                  if (item === "") {
                    return true;
                  }
                  return /^https?:\/\//.test(item);
                });
                return flag;
              },
              error: "应用回调域地址不正确",
            },
            {
              func: () => {
                // eslint-disable-next-line no-control-regex
                return /^[\x00-\xff]*$/.test(this.companyCoreCallbackURL);
              },
              error: "输入内容不能包含中文和全角字符",
            },
            {
              func: () => {
                const urlArr = this.companyCoreCallbackURL.split(";");
                if (urlArr.length > 3) {
                  return false;
                }
                return true;
              },
              error: "最多可填三个域名",
            },
          ],
        },
        signatureName: {
          showError: false,
          required: true,
          errorStyle: {
            "margin-left": "160px",
          },
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.signatureName);
              },
              error: "不能包含空格",
            },
          ],
        },
        adminName: {
          showError: false,
          required: true,
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.adminName);
              },
              error: "不能包含空格",
            },
            {
              func: () => {
                return this.adminName.length > 1;
              },
              error: "联系人需要两个字符以上",
            },
          ],
        },
        adminMail: {
          showError: false,
          required: true,
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.adminMail);
              },
              error: "不能包含空格",
            },
            {
              func: () => {
                return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(
                  this.adminMail
                );
              },
              error: "邮箱格式不正确",
            },
          ],
        },
        adminPhone: {
          showError: false,
          required: true,
          validatorList: [
            {
              func: () => {
                return !/\s/.test(this.adminPhone);
              },
              error: "不能包含空格",
            },
          ],
        },
      },
      lock: 0,
    };
  },
  async mounted() {
    const companyInfo = this.$store.state.companyInfo;
    if (companyInfo && companyInfo.state === 1) {
      await this.getSafetyReport();
      this.$LogReport.sendCustomEvent("openplat_appinformation_edit_page_load");
      this.getCompanyCoreDetail().catch((e) => {
        this.$notify({
          content: e.message,
          type: "error",
          offset: 60,
          duration: 1500,
        });
      });
      axios
        .get(this.app_safety_test, {
          responseType: "blob",
        })
        .then(({ data }) => {
          this.app_safety_test = URL.createObjectURL(data);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      this.$router.push({
        name: "companyCore",
      });
    }
    if (this.isEditWebhooks) {
      this.callback_url =
        this.$route.query.callback_url === "-"
          ? ""
          : this.$route.query.callback_url;
      if (!this.callback_url) {
        this.upsetDisabled = true;
      }
      setTimeout(() => {
        window.scrollTo({
          top: 1800,
          behavior: "smooth",
        });
      }, 100);
    }
  },
  watch: {
    adminPhone() {
      this.verificationCode = "";
      this.$refs["bcc-verification"].content = "获取验证码";
      if (
        this.adminPhone &&
        /^1/.test(this.adminPhone) &&
        this.adminPhone.length == 11
      ) {
        if (this.$route.query.client_id) {
          this.canSendCaptcha = this.adminPhone !== this.oldAdminPhone;
        } else this.canSendCaptcha = true;
      } else this.canSendCaptcha = false;
    },
  },
  created() {
    if (this.$route.query.client_id) {
      this.getWhether();
    }
  },
  methods: {
    handleTestChange() {
      this.$forceUpdate();
    },
    async getSafetyReport() {
      const data = await this.$api.companyCore.getSafetyReport();
      let { result, item } = data;
      this.resultList = result;
      this.safetyList = item;
      item.forEach((item) => {
        this.safety_test_report[item.code] = "";
      });
    },
    changeStatus(val) {
      if (!val) {
        this.upsetDisabled = false;
      } else {
        this.upsetDisabled = true;
      }
    },
    async upsetWebhooks() {
      this.$LogReport.sendCustomEvent("openplat_webhooks_update");
      const data = await this.$api.companyCore.upsetCbUrl({
        client_id: this.$route.query.client_id,
        callback_url: this.callback_url,
      });
      if (data.code === 0) {
        this.$message({
          content: "操作成功",
          type: "success",
          offset: 60,
          duration: 1500,
        });
        this.$router.back(-1);
      } else {
        this.$message({
          content:
            data.message + ",请检查回调地址是否正确" ||
            "Webhooks消息回调地址验证失败！",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
      }
    },
    async handleWebhooks() {
      if (this.canValidate || this.prev === this.callback_url) return;
      this.webhooksLoading = true;
      this.$LogReport.sendCustomEvent("openplat_webhooks_validate");
      const data = await this.$api.companyCore.verifyCbUrl({
        client_id: this.$route.query.client_id,
        callback_url: this.callback_url,
      });
      this.webhooksLoading = false;
      this.prev = this.callback_url;
      if (data.code === 0) {
        this.$message({
          content: "Webhooks消息回调地址验证成功",
          type: "success",
          offset: 60,
          duration: 1500,
        });
        this.upsetDisabled = false;
      } else {
        this.validator.callback_url.showError = true;
        this.upsetDisabled = true;
        this.$refs.callback_url.validatorMsg = data.message;
      }
    },
    async verrifyAppName() {
      if (this.companyCoreName.length < 2) return;
      const data = await this.$api.companyCore.verifyAppName({
        app_name: this.companyCoreName,
      });
      if (data.exists) {
        this.validator.companyCoreName.showError = true;
        this.appNameExist = true;
      }
    },
    async getCompanyCoreDetail() {
      if (this.$route.query.client_id) {
        const client_id = this.$route.query.client_id;
        const data = await this.$api.companyCore.view(client_id);
        this.companyCoreName = data.app_name;
        this.iconUrl = data.cover;
        this.$refs["icon"].state = 2;
        this.companyCoreAddType = data.app_type;
        this.companyCoreAddPlat = data.app_plat;
        this.companyCoreDescription = data.dsc;
        this.companyCoreHomeAddr = data.site;

        this.adminName = data.contact;
        this.oldAdminPhone = this.adminPhone = data.tel;
        this.adminMail = data.email;
        try {
          if (data.safety_test_report !== "{}") {
            this.safety_test_report = JSON.parse(data.safety_test_report);
          }
        } catch (e) {
          console.log(e);
        }

        if (data.app_plat.includes(0)) {
          this.iOS = true;
          this.iOSPublished = data.ios_oauth_info.is_online;
          this.appStoreURL = data.ios_oauth_info.download_url;
          this.bundleId = data.ios_oauth_info.bundle_id;
        }
        if (data.app_plat.includes(1)) {
          this.android = true;
          this.androidPublished = data.android_oauth_info.is_online;
          this.androidStoreURL = data.android_oauth_info.download_url;
          this.packageName = data.android_oauth_info.apk_name;
          this.signatureName = data.android_oauth_info.apk_sign;
        }
        if (data.app_plat.includes(2)) {
          this.PC = true;
          this.companyCoreCallbackURL = data.oauth_info.cburl;
        }
      }
    },
    confirmAddCompanyCore() {
      try {
        for (let i in this.safety_test_report) {
          if (!this.safety_test_report[i]) {
            this.$message({
              // content: `未勾选应用安全测试-${this.safetyList.filter((item) => item.code === i)[0].title.split('（')[0]}`,
              content: "未勾选全部应用安全测试结果",
              type: "exception",
              offset: 60,
              duration: 1500,
            });
            return;
          }
        }
      } catch (e) {
        console.log(e);
      }
      if (this.$route.query.client_id)
        this.$LogReport.sendCustomEvent(
          "openplat_appinformation_edit_submit_click"
        );
      else
        this.$LogReport.sendCustomEvent("openplat_appinformation_submit_click");
      this.companyCoreAddPlat = [];

      if (!this.companyCoreName) {
        this.$message({
          content: "未填写应用名称",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.companyCoreHomeAddr) {
        this.$message({
          content: "未填写应用网址",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (
        this.companyCoreHomeAddr &&
        !/^https?:\/\//.test(this.companyCoreHomeAddr)
      ) {
        this.$message({
          content: "应用网址不正确",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.companyCoreDescription) {
        this.$message({
          content: "未填写应用简介",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (this.companyCoreDescription.length < 5) {
        this.$message({
          content: "请最少输入5个字的应用简介",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.iconUrl) {
        this.$message({
          content: "未上传应用图标",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.iOS && !this.android && !this.PC) {
        this.become = true;
        this.$message({
          content: "请选择平台(应用类型)",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      } else {
        this.become = false;
      }
      if (this.iOS) {
        this.companyCoreAddPlat.push(0);
        if (!this.bundleId) {
          this.$message({
            content: "未填写Bundle ID",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
          return;
        }
        this.iOSAuthInfo = {
          is_online: this.iOSPublished,
          download_url: this.appStoreURL,
          bundle_id: this.bundleId,
        };
      }
      if (this.android) {
        this.companyCoreAddPlat.push(1);
        if (!this.packageName) {
          this.$message({
            content: "未填写应用包名",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
          return;
        }
        if (!this.signatureName) {
          this.$message({
            content: "未填写应用签名",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
          return;
        }
        this.androidAuthInfo = {
          is_online: this.androidPublished,
          download_url: this.androidStoreURL,
          apk_name: this.packageName,
          apk_sign: this.signatureName,
        };
      }
      if (this.PC) {
        this.companyCoreAddPlat.push(2);
        if (!this.companyCoreCallbackURL) {
          this.$message({
            content: "未填写应用回调域",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
          return;
        }
        this.webAuthInfo = {
          cburl: this.companyCoreCallbackURL,
        };
      }

      if (!this.companyCoreAddPlat.length) {
        this.$message({
          content: "未选择应用平台",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.adminName) {
        this.$message({
          content: "未填写联系人",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.adminMail) {
        this.$message({
          content: "未填写联系邮箱",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.adminMail)) {
        this.$message({
          content: "邮箱格式不正确",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (!this.adminPhone) {
        this.$message({
          content: "未填写联系手机",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      if (
        !this.verificationCode &&
        (!this.$route.query.client_id || this.adminPhone !== this.oldAdminPhone)
      ) {
        this.$message({
          content: "未填写验证码",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }

      let appData = {
        app_name: this.companyCoreName,
        app_type: this.companyCoreAddType,
        app_plat: Array.from(new Set(this.companyCoreAddPlat)),
        site: this.companyCoreHomeAddr,
        dsc: this.companyCoreDescription,
        cover: this.iconUrl,
        contact: this.adminName,
        tel: this.adminPhone,
        email: this.adminMail,
        oauth_info: this.webAuthInfo,
        ios_oauth_info: this.iOSAuthInfo,
        android_oauth_info: this.androidAuthInfo,
        captcha: this.verificationCode,
        safety_test_report: JSON.stringify(this.safety_test_report),
      };

      if (this.$route.query.client_id) {
        appData.client_id = this.$route.query.client_id;
        appData.app_type = 3;
        this.$api.companyCore
          .edit(appData)
          .then(() => {
            this.$LogReport.sendCustomEvent(
              "openplat_appinformation_edit_submit_success"
            );
            this.$router.push({
              name: "companyCoreAddComplete",
            });
          })
          .catch((e) => {
            console.error(e);
            this.$message({
              content: e.message,
              type: "exception",
              offset: 60,
              duration: 1500,
            });
          });
      } else {
        appData.app_type = 3;
        this.$api.companyCore
          .submit(appData)
          .then(() => {
            this.$LogReport.sendCustomEvent(
              "openplat_appinformation_submit_success"
            );
            this.$router.push({
              name: "companyCoreAddComplete",
            });
          })
          .catch((e) => {
            this.$notify({
              content: e.message,
              type: "error",
              offset: 60,
              duration: 1500,
            });
          });
      }
    },
    async iconUploader(file) {
      if (file.size > 400 * 1024) {
        this.$message({
          content: "应用图标过大",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
        return;
      }
      return await this.$api.companyCore
        .iconUpload(file)
        .then((data) => {
          this.iconUrl = data.url;
          return data.url;
        })
        .catch((e) => {
          console.error(e);
          this.$message({
            content: "上传应用图标失败",
            type: "exception",
            offset: 60,
            duration: 1500,
          });
        });
    },
    async sendVerification(startCountDown) {
      this.canInputPhone = false;
      let tid = setTimeout(() => (this.canInputPhone = true), 60000);
      try {
        await this.$api.verify.sendCaptch({
          mobile: this.adminPhone,
        });
        startCountDown();
      } catch (e) {
        this.canInputPhone = true;
        clearTimeout(tid);
        this.$message({
          content: "获取验证码失败",
          type: "exception",
          offset: 60,
          duration: 1500,
        });
      }
    },
    async getWhether() {
      const params = {
        client_id: this.$route.query.client_id,
      };
      const data = await whether(params);
      const { lock } = data;
      this.lock = lock;
    },
  },
};
</script>

<style scoped lang="scss">
.tip-red {
  color: red !important;
}
.company-core-add {
  max-width: 1168px;
  min-width: 960px;
  margin: 0 auto;
}

.company-core-add-head {
  padding: 20px 0 20px 26px;
}

.line {
  border-bottom: solid 1px #e7e7e7;
  margin-bottom: 4px;
}

.company-core-add-body {
  border: 1px solid #e7e7e7;
  min-height: 100px;

  .company-core-add-body-h {
    display: flex;
    align-items: center;
    padding: 0 26px;
    border-bottom: 1px solid #e7e7e7;
    height: 64px;
    justify-content: space-between;
    font-size: 24px;
    color: #212121;
    line-height: 24px;
    font-weight: 600;
  }

  .company-core-add-form {
    //padding: 72px 0;
    padding: 31px 120px;
    text-align: center;

    .h2 {
      font-size: 20px;
      color: #212121;
      font-weight: 500;
      margin: 28px auto 28px 28px;
      text-align: left;
    }

    .form-item {
      display: flex;
      align-items: center;
      //width: 869px;
      margin: 0 auto 32px 31px;

      .label {
        font-size: 14px;
        color: #212121;
        //margin-right: 22px;
        display: inline-block;
        width: 89px;
        text-align: left;
      }

      .app-label {
        font-size: 14px;
        color: #212121;
        //margin-right: 22px;
        display: inline-block;
        width: 130px;
        text-align: left;
      }
      .webhooks-label {
        font-size: 14px;
        color: #212121;
        //margin-right: 22px;
        display: inline-block;
        width: 110px;
        text-align: left;
      }

      .required {
        color: #fa5a57;
        margin-right: 4px;
      }
    }
  }

  .webhooks-txt {
    margin-top: -20px !important;
    margin-left: -170px !important;
    color: #999999;
    font-size: 14px;
  }
  .company-core-add-platform {
    display: flex;
    align-items: center;
  }

  .tip {
    text-align: left;
    margin-left: 24px;
    font-size: 14px;
    color: #999999;
    line-height: 20px;

    .highlight {
      color: #faab4b;
      line-height: 22px;
      font-size: 14px;
      margin-top: 7px;
    }
  }
  .exit-name {
    margin-top: -20px;
    padding-bottom: 20px;
    color: #fa5a57;
    font-size: 14px;
    margin-left: 120px;
    text-align: left;
  }
  .help-img {
    cursor: pointer;
  }
  .des-txt {
    width: 550px;
    font-size: 14px;
    // color: #FA5A57;
    .text-indent {
      margin-top: 2px;
      margin-left: 22px;
    }
  }
  .app-test {
    flex-direction: column;
    align-items: flex-start !important;
    margin-left: 200px;
    .container {
      display: flex;
      align-items: center;
    }
    .label {
      width: 110px !important;
    }
  }
  .app-test-txt {
    margin-top: 10px;
    margin-left: 108px;
    font-size: 14px;
    color: #999999;
  }
  .validate-icon {
    margin-left: 10px;
    width: 20px;
    height: 20px;
    // cursor:pointer;
  }
  .rotate {
    -webkit-animation: myRotate 1s linear infinite;
    animation: myRotate 1s linear infinite;
  }
  @-webkit-keyframes myRotate {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes myRotate {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
}
</style>
